
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/recommendations",
      function () {
        return require("private-next-pages/learn/recommendations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/recommendations"])
      });
    }
  